import { useMemo } from 'react';

import { AddCircleOutlineOutlined } from '@lichtblick/icons';
import { TeamUser, GetAppointmentWorkforceUserPayloadModel, UserPayloadModel } from '@lichtblick/types';

import {
  AutocompleteItemInfo,
  AutocompleteItemInfoBottom,
  AutocompleteItemInfoName,
  AutocompleteItemInfoText,
  AutocompleteItemTeam,
} from './Autocomplete.styles';

type SelectTeamProps = TeamUser & {
  team: GetAppointmentWorkforceUserPayloadModel[] | UserPayloadModel[];
};

export const SelectTeam = ({ email, id, label, team }: SelectTeamProps) => {
  const isInTeam = useMemo(() => team.some((user) => user?.id.toString() === id), [team, id]);

  return (
    <AutocompleteItemTeam>
      <AutocompleteItemInfo>
        <AutocompleteItemInfoName>{label}</AutocompleteItemInfoName>
        <AutocompleteItemInfoBottom>
          <AutocompleteItemInfoText>{email}</AutocompleteItemInfoText>
        </AutocompleteItemInfoBottom>
      </AutocompleteItemInfo>
      <AddCircleOutlineOutlined color={isInTeam ? 'disabled' : 'primary'} />
    </AutocompleteItemTeam>
  );
};
